// export const DATA_DETAIL = `${process.env.REACT_APP_API_HOST}/client/api/product/detail`
// export const DATA_DETAIL = `/api/product/detail`
export const DATA_DETAIL = `/api/design`
export const DESIGNER_FONT = `/api/crud/designer_font`
export const DESIGNER_PATTERN_CATEGORY = `/api/crud/designer_pattern_category`
export const DESIGNER_PATTERN = `/api/crud/designer_pattern`
export const DESIGNER_COLOR = `/api/crud/designer_color`
export const UPLOAD_IMAGE = `/api/upload/diy`
export const CART_ADD = `/api/cart/add`
export const USER_DESIGNER_list = `api/crud/user_designer/index`
export const USER_DESIGNER = `/api/crud/user_designer`

// 新建设计与修改设计  取消掉api是因为次接口是用于传输到其他端的操作 其他端会自动拼接
export const USER_DESIGNER_UPDATE = `/api/crud/user_designer/update` // 更新设计
export const USER_DESIGNER_SAVE = `/api/crud/user_designer/save` // 保存设计

export const GET_OSS_UPLOAD_CONFIG = `/api/get_oss_upload_config` // 保存设计



// export const PATTERN_LIST = `/client/api/pattern/list`
// export const FONT_LIST = `/client/api/font/list`
// export const ORDER_CREATE = `/client/api/order/create`
// export const ORDER_LIST = `/client/api/order/list`
// export const ORDER_PAY = `/client/api/order/pay`

// export const WX_LOGIN = `/client/open/login/wxgz`
// export const GUEST_LOGIN = `/client/open/login/guest`

// export const WX_JSSDK = `/client/open/wxconfig/jssdk`


